// extracted by mini-css-extract-plugin
module.exports = {"mobile-wrap":"carousel_mobile-wrap__YlYlo","carousel":"carousel_carousel__5Jljs"};